export const studentLink = (route, oktaId) => {
  return {
    name: "student-management",
    params: {
      ...route.params,
      page: "student-detail",
      oktaId: oktaId ?? "",
    },
    query: { ...route.query },
  };
};

export const ONBOARDING_PAGES = {
  legacy: "forms",
  dashboard: "onboarding-dashboard",
};

export const ONBOARDING_LABELS = {
  legacy: "Onboarding To-Dos",
  dashboard: "Onboarding Dashboard",
};

export const getOnboardingPage = (isDashboardEnabled) =>
  isDashboardEnabled ? ONBOARDING_PAGES.dashboard : ONBOARDING_PAGES.legacy;

export const getOnboardingLabel = (isDashboardEnabled) =>
  isDashboardEnabled ? ONBOARDING_LABELS.dashboard : ONBOARDING_LABELS.legacy;

export const resolveOnboardingPageRedirect = (to, isDashboardEnabled) => {
  const page = getOnboardingPage(isDashboardEnabled);
  const stalePage = getOnboardingPage(!isDashboardEnabled);

  return to.params?.page === stalePage
    ? { name: to.name, params: { ...to.params, page }, query: to.query, hash: to.hash }
    : true;
};
